let baseClass = 'accordion';

const BoneAccordions = (() => {
	const accs = {
		instances: [],
		settings: {},
	};

	accs.getSegments = function(accordian) {
		const segments = Array.from(accordian.querySelectorAll(`.${baseClass}__segment`));
		return segments;
	}

	accs.hasExpandedSegment = function(accordian) {

	}

	accs.getExpandedSegment = function(accordian) {

	}

	accs.getSegmentAccordian = function(segment) {
		return segment.closest(`.${baseClass}`);
	}

	accs.isSegmentExpanded = function(segment) {
		const {toggle} = accs._getSegmentParts(segment);

		let state = undefined;
		if (toggle.hasAttribute('aria-expanded')) {
			state = toggle.getAttribute('aria-expanded') === 'true' ? true : false;
		}

		return state;
	}

	accs.expandSegment = function(segment) {
		const {
			header,
			body,
			toggle,
		} = accs._getSegmentParts(segment);

		toggle.setAttribute('aria-expanded', 'true');
		body.setAttribute('aria-hidden', 'false');

		if (accs.settings.expandAnimationCB) {
			accs.settings.expandAnimationCB(segment);
		}
	}

	accs.greedilyExpandSegment = function(segment) {
		accs.expandSegment(segment);
		const accordian = accs.getSegmentAccordian(segment);
		if (accordian) {
			const siblings = accs.getSegments(accordian).filter(s => s !== segment);
			siblings.forEach(toCollapse => {
				if (accs.isSegmentExpanded(toCollapse)) {
					accs.collapseSegment(toCollapse);
				}
			});
		}
	}

	accs.collapseSegment = function(segment) {
		const {
			header,
			body,
			toggle,
		} = accs._getSegmentParts(segment);

		toggle.setAttribute('aria-expanded', 'false');
		body.setAttribute('aria-hidden', 'true');

		if (accs.settings.collapseAnimationCB) {
			accs.settings.collapseAnimationCB(segment);
		}
	}

	accs.greedilyCollapseSegment = function(segment) {
		accs.collapseSegment(segment);
	}

	accs._getSegmentParts = function(segment) {
		const header = segment.querySelector(`.${baseClass}__segment-header`);
		const toggle = segment.querySelector(`.${baseClass}__segment-toggle`);
		const body = segment.querySelector(`.${baseClass}__segment-body`);

		return {
			header,
			body,
			toggle,
		};
	}

	accs.unload = function() {
		if (accs.instances) {
			accs.instances = [];
		}
	}

	accs.init = function(settings = {}) {
		if (settings.baseClass) {
			baseClass = settings.baseClass;
		}

		const defaultSettings = {
			baseClass: baseClass,
			openMultiple: true,
		}

		settings = Object.assign({}, defaultSettings, settings);

		accs.settings = settings;

		const uninstantiated = Array.from(document.querySelectorAll(`.${baseClass}`));

		if (!uninstantiated.length) {
			return;
		}

		uninstantiated.forEach(accElement => {
			const segments = accs.getSegments(accElement);

			segments.forEach(segment => {
				const {toggle} = accs._getSegmentParts(segment);
				toggle.addEventListener('click', () => {
					if (accs.isSegmentExpanded(segment)) {
						accs.collapseSegment(segment);
					}
					else {
						if (accs.settings.openMultiple) {
							accs.expandSegment(segment);
						}
						else {
							accs.greedilyExpandSegment(segment);
						}
					}
				});

				if (accs.settings.animationSetupCB) {
					accs.settings.animationSetupCB(segment);
				}
			});
		});
	}

	return accs;
})();

export default BoneAccordions;



// WEBPACK FOOTER //
// ./scripts/modules/bone-accordion.js